import { useState } from 'react';
import { Button } from '@tempmee/react';
import type { TViewedOfficeScope } from '~/types/ViewedOfficeScope';
import { DownloadReportPopup } from '../Popup';

interface IProps {
  scope: TViewedOfficeScope;
}

export const DownloadReportButton = ({ scope }: IProps) => {
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false);

  return (
    <>
      <Button data-cy="btn-export-report" size="xs" onClick={() => setIsShowPopup(true)}>
        Download Report
      </Button>
      {isShowPopup && (
        <DownloadReportPopup scope={scope} onClosePopup={() => setIsShowPopup(false)} />
      )}
    </>
  );
};
